(function ($) {
  Drupal.behaviors.get_the_look_formatter_v1 = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;

      var $thismodule = $('.get-the-look-v1', context);

      $thismodule.each(function () {
        var $module = $(this),
          $parent = $module.closest('.js-get-the-look'),
          $panels = $module.find('.js-lookmod-panel'),
          $navContainer = $module.find('.js-nav-container'),
          $navThumbs,
          mobileWidth = 768,
          currentSlide;

        // Initial Nav panel setup
        function createNavPanel() {
          $.each($panels, function (panelIndex, panelValue) {
            var $panel = $(panelValue),
              $panelImgSrc = $panel.find('.lookmod__slide-img').attr('src'),
              $navItemElement =
                '<div class="get-the-look__navigationthumb js-nav-thumb" data-thumb-index="' +
                panelIndex +
                '"><img src="' +
                $panelImgSrc +
                '" loading="lazy" /></div>';

            $navContainer.append($navItemElement);
          });
        }
        createNavPanel();

        // set the initial active class
        function setInitialClasses($panel) {
          $panel.addClass('lookmod__slide--active');
        }
        $.each($panels, function (panelIndex, panelValue) {
          var $panel = $(panelValue);

          if (panelIndex === 0) {
            setInitialClasses($panel);
          }
        });

        function setCurrentPanel(index) {
          var $currentPanel = $($panels[index]);

          $currentPanel.addClass('lookmod__slide--active');
          $.each($navThumbs, function (nav_index, nav_thumb) {
            var $navThumb = $(nav_thumb);

            $navThumb.removeClass('get-the-look__navigationthumb--active');
            if (index === Number($navThumb.data('thumb-index'))) {
              $navThumb.addClass('get-the-look__navigationthumb--active');
            }
          });
        }

        // event handler for nav click
        function handleNavThumbClicked($navThumb) {
          var navIndex = Number($navThumb.data('thumb-index'));

          $panels.removeClass('lookmod__slide--active');
          setCurrentPanel(navIndex);
          mobileLayout();
          updateProductsCarousel(navIndex);
        }

        function hideShowCarousels($carousels, navIndex) {
          if ($carousels && $carousels.length > 0) {
            var $currentCarousel;

            $carousels.removeClass('active');
            $currentCarousel = $($carousels[navIndex]);
            $currentCarousel.addClass('active');
            $currentCarousel.find('.js-product-brief-carousel-items').get(0).slick.setPosition();
          }
        }

        function updateProductsCarousel(navIndex) {
          var $carouselContainer, $carousels;

          if ($parent && $parent.length > 0) {
            $carouselContainer = $parent.siblings('.js-get-the-look-carousel-container');
          }
          if ($carouselContainer && $carouselContainer.length > 0) {
            $carousels = $carouselContainer.find('.js-get-the-look-carousel');
            hideShowCarousels($carousels, navIndex);
          }
        }

        // Move nav panel below main image for mobile
        function updateActivePanel() {
          var $activePanel;

          $.each($panels, function (panelIndex, panelValue) {
            var $panel = $(panelValue);

            if ($panel.hasClass('lookmod__slide--active')) {
              $activePanel = $panel;
            }
          });
          if ($activePanel && $activePanel.length > 0) {
            var $imgcontainer = $activePanel.find('.lookmod__slide-imgcontainer');

            $navContainer.insertAfter($imgcontainer);
          }
        }

        // Convert the nav into a carousel if theres more than four items
        // Slick Carousel setup
        if ($panels.length > 4) {
          var $nav = $module.find('.js-nav-container');

          $nav.slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            rtl: site.direction.isRTL,
            draggable: false
          });
        }

        function getUrlParams() {
          var params = {};

          window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (str, key, value) {
            params[key] = value;
          });
          if (params['s_index'] && params['s_index'] < $panels.length) {
            return Number(params['s_index']);
          }

          return 0;
        }
        currentSlide = getUrlParams();
        $navThumbs = $module.find('.js-nav-thumb');
        $panels.removeClass('lookmod__slide--active');
        setCurrentPanel(currentSlide);

        $.each($navThumbs, function (navThumbIndex, navThumbValue) {
          var $navThumb = $(navThumbValue);

          $navThumb.on('click', function () {
            handleNavThumbClicked($(this), navThumbIndex);
            var scrollPos = $(window).scrollTop();

            window.scrollTo(0, scrollPos);
          });
        });

        // The nav panel is laid out different for mobile.
        function mobileLayout() {
          var windowWidth = $(window).width();

          if (windowWidth < mobileWidth) {
            updateActivePanel();
          }
        }
        mobileLayout();

        // Handle html layout on window resizing
        $(window).on('resize', _.debounce(mobileLayout, 100));
      });
    }
  };
})(jQuery);
